var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "b-card",
                { staticClass: "card-statistics", attrs: { "no-body": "" } },
                [
                  _c(
                    "b-card-header",
                    [
                      _c("b-card-title", [_vm._v("Tickets Status")]),
                      _c("b-card-text", { staticClass: "mr-25 mb-0" }, [
                        _vm._v(" Updated 1 day ago "),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "b-card-body",
                    { staticClass: "statistics-body" },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "mb-2 mb-md-0",
                              attrs: { md: "6", sm: "6" },
                            },
                            [
                              _c(
                                "b-media",
                                { attrs: { "no-body": "" } },
                                [
                                  _c(
                                    "b-media-aside",
                                    { staticClass: "mr-2" },
                                    [
                                      _c(
                                        "b-avatar",
                                        {
                                          attrs: {
                                            size: "48",
                                            variant: "light-danger",
                                          },
                                        },
                                        [
                                          _c("feather-icon", {
                                            attrs: {
                                              size: "24",
                                              icon: "SlashIcon",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-media-body",
                                    { staticClass: "my-auto" },
                                    [
                                      _c(
                                        "h4",
                                        {
                                          staticClass:
                                            "font-weight-bolder mb-0",
                                        },
                                        [
                                          _vm._v(
                                            " Open : " +
                                              _vm._s(_vm.statusCounts["Open"]) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            {
                              staticClass: "mb-2 mb-md-0",
                              attrs: { md: "6", sm: "6" },
                            },
                            [
                              _c(
                                "b-media",
                                { attrs: { "no-body": "" } },
                                [
                                  _c(
                                    "b-media-aside",
                                    { staticClass: "mr-2" },
                                    [
                                      _c(
                                        "b-avatar",
                                        {
                                          attrs: {
                                            size: "48",
                                            variant: "light-success",
                                          },
                                        },
                                        [
                                          _c("feather-icon", {
                                            attrs: {
                                              size: "24",
                                              icon: "CheckSquareIcon",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-media-body",
                                    { staticClass: "my-auto" },
                                    [
                                      _c(
                                        "h4",
                                        {
                                          staticClass:
                                            "font-weight-bolder mb-0",
                                        },
                                        [
                                          _vm._v(
                                            " Closed : " +
                                              _vm._s(
                                                _vm.statusCounts["Closed"]
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "b-card",
                { staticClass: "card-statistics", attrs: { "no-body": "" } },
                [
                  _c(
                    "b-card-header",
                    [
                      _c("b-card-title", [_vm._v("Tickets Priorities")]),
                      _c("b-card-text", { staticClass: "mr-25 mb-0" }, [
                        _vm._v(" Updated 1 day ago "),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "b-card-body",
                    { staticClass: "statistics-body" },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "mb-2 mb-md-0",
                              attrs: { md: "4", sm: "6" },
                            },
                            [
                              _c(
                                "b-media",
                                { attrs: { "no-body": "" } },
                                [
                                  _c(
                                    "b-media-aside",
                                    { staticClass: "mr-2" },
                                    [
                                      _c(
                                        "b-avatar",
                                        {
                                          attrs: {
                                            size: "48",
                                            variant: "light-success",
                                          },
                                        },
                                        [
                                          _c("feather-icon", {
                                            attrs: {
                                              size: "24",
                                              icon: "AlertCircleIcon",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-media-body",
                                    { staticClass: "my-auto" },
                                    [
                                      _c(
                                        "h4",
                                        {
                                          staticClass:
                                            "font-weight-bolder mb-0",
                                        },
                                        [
                                          _vm._v(
                                            " Low : " +
                                              _vm._s(
                                                _vm.priorityCounts["Low"]
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            {
                              staticClass: "mb-2 mb-md-0",
                              attrs: { md: "4", sm: "6" },
                            },
                            [
                              _c(
                                "b-media",
                                { attrs: { "no-body": "" } },
                                [
                                  _c(
                                    "b-media-aside",
                                    { staticClass: "mr-2" },
                                    [
                                      _c(
                                        "b-avatar",
                                        {
                                          attrs: {
                                            size: "48",
                                            variant: "light-warning",
                                          },
                                        },
                                        [
                                          _c("feather-icon", {
                                            attrs: {
                                              size: "24",
                                              icon: "AlertOctagonIcon",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-media-body",
                                    { staticClass: "my-auto" },
                                    [
                                      _c(
                                        "h4",
                                        {
                                          staticClass:
                                            "font-weight-bolder mb-0",
                                        },
                                        [
                                          _vm._v(
                                            " Medium : " +
                                              _vm._s(
                                                _vm.priorityCounts["Medium"]
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            {
                              staticClass: "mb-2 mb-md-0",
                              attrs: { md: "4", sm: "6" },
                            },
                            [
                              _c(
                                "b-media",
                                { attrs: { "no-body": "" } },
                                [
                                  _c(
                                    "b-media-aside",
                                    { staticClass: "mr-2" },
                                    [
                                      _c(
                                        "b-avatar",
                                        {
                                          attrs: {
                                            size: "48",
                                            variant: "light-danger",
                                          },
                                        },
                                        [
                                          _c("feather-icon", {
                                            attrs: {
                                              size: "24",
                                              icon: "AlertTriangleIcon",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-media-body",
                                    { staticClass: "my-auto" },
                                    [
                                      _c(
                                        "h4",
                                        {
                                          staticClass:
                                            "font-weight-bolder mb-0",
                                        },
                                        [
                                          _vm._v(
                                            " High : " +
                                              _vm._s(
                                                _vm.priorityCounts["High"]
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }